/**
 * The app changelog ("Was ist neu" modal, account-menu entry, avatar dot) is an
 * internal dev/staging feature. Customer deployments share the same build
 * artifact, so visibility is decided at runtime by hostname.
 */
const INTERNAL_CHANGELOG_HOSTNAMES: readonly string[] = ['mc.infra-struktur.app', 'staging.infra-struktur.app'];

/**
 * Pure decision function: the changelog is visible on internal hosts and in
 * local dev builds (`quasar dev`), never on customer hosts or in packaged
 * Capacitor apps (which serve from `localhost` but are production builds).
 */
export function isChangelogEnabledForHost(hostname: string, isDevBuild: boolean): boolean {
	return isDevBuild || INTERNAL_CHANGELOG_HOSTNAMES.includes(hostname.toLowerCase());
}

/**
 * Runtime gate used by App bootstrap and toolbar components.
 */
export function isChangelogEnabled(): boolean {
	if (typeof window === 'undefined') {
		return false;
	}
	return isChangelogEnabledForHost(window.location.hostname, Boolean(process.env.DEV));
}
